import type { ReactNode } from "react";
import { AlertOctagon, AlertTriangle, Circle } from "lucide-react";
import { useIntl } from "react-intl";
import { cx } from "../cx.js";
import styles from "./Badge.module.css";

export interface BadgeProps {
  tone?: "neutral" | "accent" | "success" | "warning" | "danger";
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return <span className={cx(styles.badge, styles[tone], className)}>{children}</span>;
}

export type Urgency = "rot" | "gelb" | "gruen";

const URGENCY_ICON = { rot: AlertOctagon, gelb: AlertTriangle, gruen: Circle } as const;

/** Dringlichkeit mit Form, Symbol und Text – nie nur Farbe (WCAG 1.4.1). */
export function UrgencyBadge({ urgency, className }: { urgency: Urgency; className?: string }) {
  const intl = useIntl();
  const Icon = URGENCY_ICON[urgency];
  return (
    <span className={cx(styles.urgency, styles[`u_${urgency}`], className)}>
      <Icon className={styles.urgencyIcon} aria-hidden="true" />
      {intl.formatMessage({ id: `urgency.${urgency}` })}
    </span>
  );
}
